import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import SecondaryButton from "../../components/SecondaryButton";
import { Breadcrumbs, Button, Snackbar } from "@mui/material";
import { Policy, Driver } from "../../objects/policy";
import ListDrivers from "../../components/quoting/ListDrivers";
import EditDriverForm from "../../components/EditDriverForm";
import { RatingService } from "../../services/ratingservice";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Alert, { AlertColor } from "@mui/material/Alert";
import dayjs from "dayjs";
import { Toast } from "../../components/alerts/toast";
import { logActivityAsync } from "../../objects/events/loadEvents";
function Drivers() {
    let ratingService = new RatingService();

    var navigate = useNavigate();
    const dispatch = useDispatch();

    const policyStore = useSelector((state: any) => state.policyReducer) as Policy;
    const [isPageLoad, setIsPageLoad] = useState(true);
    const [isAddDriverVisible, setIsAddDriverVisible] = useState(false);
    const [policy, setPolicy] = useState<Policy>(new Policy());

    const [open, setOpen] = React.useState(false);
    const [isOpenErrorAlert, setIsOpenErrorAlert] = React.useState(false);
    const [errorMessages, setErrorMessages] = useState<string[]>([]);
    const [toastSeverity, setToastSeverity] = useState<AlertColor>("info");

    useEffect(()=>{
        (async()=>{
            await logActivityAsync(policy?.policyNumber ?? "", {
                recordKey: policy?.policyNumber,
                transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                action: "add_activity",
                subject: "Navigation",
                message: "Insured has navigated to the drivers screen",
                isException:false,
                error: "",
                level:"INFO",
                isSent: false
            });
        })();
    }, []);

    useEffect(() => {

        if (policyStore === undefined || policyStore == null) {
            navigate("/" + window.location.search);
        }

        if (isPageLoad) {
            window.scrollTo(0, 0);
            setPolicy(policyStore);
            setIsPageLoad(false);
        }

        document.querySelector(".container-new-driver")?.classList.remove("expanded");
        document.querySelector(".row-add-driver")?.classList.add("rounded-br-lg");
        document.querySelector(".row-add-driver")?.classList.add("rounded-bl-lg");

        var labels = document.getElementsByClassName("btn-main-label");

        for (let item of labels) {
            //item?.classList.toggle("hidden");
        }

    }, [policy]);

    const handleClose = () => {
        setOpen(false);
    };

    const handleErrorAlertClose = () => {
        setIsOpenErrorAlert(false);
    };

    function NavigateBack() {
        navigate("/vehicles" + window.location.search);
    }

    function NavigateForward() {

        (async () => {
            var isDriversValid = isValid();
            if (!isDriversValid) {
                return;
            }
            policy.integrationId = policy.policyNumber;
            dispatch({ type: "UPDATE", payload: policy })
            navigate("/review" + window.location.search);
        })();
    }

    function isValid() {
        var messages: string[] = [];
        setIsOpenErrorAlert(false);

        if (messages.length > 0) {
            setErrorMessages(messages);
            setToastSeverity("error");
            setIsOpenErrorAlert(true);

            return false;
        }

        return true;
    }

    function toggleAddDriver(isAddDriverOpen: boolean) {

        setIsAddDriverVisible(isAddDriverOpen);
        var labels = document.getElementsByClassName("btn-main-label");

        document.querySelector(".row-add-driver")?.classList.toggle("rounded-br-lg");
        document.querySelector(".row-add-driver")?.classList.toggle("rounded-bl-lg");

        document.querySelector(".container-new-driver")?.classList.toggle("expanded");

        for (let item of labels) {
            item?.classList.toggle("hidden");
        }
    }

    function removeDriverAction(driverNumber: number) {
        var counter = 1;
        var cloneDrivers = [...policy.drivers] as Driver[];

        cloneDrivers.map((v,k)=>{
            if(driverNumber == v.driverNumber){
                v.status = "REVIEW";
            }
        });
        
        console.log({removed_drivers_post_update:cloneDrivers});
        var removedDriver = cloneDrivers.find(m=>m.driverNumber == driverNumber);

        policy.drivers = cloneDrivers;

        setPolicy(policy);

        (async()=>{
            await logActivityAsync(policy?.policyNumber ?? "", {
                recordKey: policy?.policyNumber,
                transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                action: "add_activity",
                subject: "Remove Driver",
                message: `Insured removed driver ${removedDriver?.firstName} ${removedDriver?.lastName} (driver# ${driverNumber}))`,
                isException:false,
                error: "",
                level:"WARN",
                isSent: false
            });
        })();

        return cloneDrivers;
    }

    function onUpdateAction(
        driverNumber: number,
        firstName: string,
        lastName: string,
        middleInitial: string,
        suffix: string,
        dateOfBirth: string,
        gender: string,
        maritalStatus: string,
        licenseNumber: string,
        isCompletedCourse: boolean) {
        var cloneDrivers = [...(policy.drivers)];
        var updateDriverIndex = (cloneDrivers?.findIndex(m => m.driverNumber === parseInt(driverNumber.toString())) ?? -1);

        var updateDriver = updateDriverIndex === -1 ? new Driver() : (cloneDrivers ?? [])[(updateDriverIndex ?? 0)];
        updateDriver.driverNumber = driverNumber;
        updateDriver.status = "RATED";
        updateDriver.dob = dayjs(dateOfBirth).toDate();
        updateDriver.firstName = firstName;
        updateDriver.lastName = lastName;
        updateDriver.middleInitial = middleInitial;
        updateDriver.suffix = suffix;
        updateDriver.gender = gender;
        updateDriver.isMarried = maritalStatus === "M";
        updateDriver.licenseNum = licenseNumber;

        var driverToReplace = cloneDrivers.find(m => m.driverNumber === driverNumber) as Driver;
        Object.assign(driverToReplace, updateDriver);

        policy.drivers = cloneDrivers;

        setPolicy(policy);

        (async()=>{
            await logActivityAsync(policy?.policyNumber ?? "", {
                recordKey: policy?.policyNumber,
                transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                action: "add_activity",
                subject: "Update Driver",
                message: `Insured updated driver ${updateDriver?.firstName} ${updateDriver?.lastName}`,
                isException:false,
                error: "",
                level:"INFO",
                isSent: false
            });
        })();

        return cloneDrivers;
    }

    function onAddAction(firstName: string,
        lastName: string,
        middleInitial: string,
        suffix: string,
        dateOfBirth: string,
        gender: string,
        maritalStatus: string,
        licenseNumber: string) {
        var driver = new Driver();
        driver.firstName = firstName;
        driver.lastName = lastName;
        driver.suffix = suffix;
        driver.middleInitial = middleInitial;
        driver.driverNumber = (policy?.drivers.length ?? 0) + 1;
        driver.gender = gender;
        driver.dob = new Date(dateOfBirth);
        driver.isMarried = maritalStatus === "M";
        driver.licenseNum = licenseNumber;

        policy.drivers = [...policy.drivers, driver];

        setPolicy(policy);

        toggleAddDriver(false);


        (async()=>{
            await logActivityAsync(policy?.policyNumber ?? "", {
                recordKey: policy?.policyNumber,
                transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                action: "add_activity",
                subject: "Add Driver",
                message: `Insured added new driver ${driver?.firstName} ${driver?.lastName}`,
                isException:false,
                error: "",
                level:"INFO",
                isSent: false
            });
        })();

        window.scrollTo(0, 0);
    }

    function logPolicyNumber(){
        console.log(policy.policyNumber);

        return <></>;
    }
    return (
        
        <>

            <div className="container-add-vehicle w-100 pt-10">
                <div className="w-[90vw] m-auto sm:w-[90vw] md:w-[90vw] lg:w-[90vw] xl:w-[60vw]">
                    <h3 className="text-3xl font-light mt-8 mb-10 w-full">
                        <Breadcrumbs>
                            <h3 className="text-2xl pb-2 mt-0">Step 4 of 7</h3>
                        </Breadcrumbs>
                        Drivers
                    </h3>
                    <h4 className="text-2xl mb-7">Please list all residents of driving age living in your household. Remove drivers that do not live at
                        your address. Add additional drivers if necessary.</h4>

                    <ListDrivers
                        policyState={policy.ratedState}
                        drivers={policy.drivers}
                        removeDriverAction={removeDriverAction}
                        onUpdateAction={onUpdateAction}
                        onCloseAction={(e: any) => {
                            setIsAddDriverVisible(false)
                            toggleAddDriver(false)
                        }}
                    />

                    {logPolicyNumber()}
                    {(policy?.drivers.length ?? 0) > 0 ? (<hr className=" mb-10 mt-10" />) : null}

                    <div className="list-new-drivers">

                        <div className="row-add-driver bg-[#e0e1dd] p-5 rounded-tl-lg rounded-tr-lg rounded-br-lg rounded-bl-lg" >
                            <span className="float-left font-bold text-lg text-ford-blue w-3/4 md:w-11/12 xl:w-11/12 2xl:w-11/12">Need to add another driver? Click Add</span>
                            <span onClick={(e) => { toggleAddDriver(!isAddDriverVisible) }} className={"float-right text-ford-blue text-lg border-l border-dashed pl-5 border-[#999999] hover:cursor-pointer btn-main-label " + (isAddDriverVisible ? "hidden" : "")}>Add</span>
                            <span onClick={(e) => { toggleAddDriver(!isAddDriverVisible) }} className={"float-right text-ford-blue text-lg border-l border-dashed pl-5 border-[#999999] hover:cursor-pointer btn-main-label " + (isAddDriverVisible ? "" : "hidden")}>Close</span>
                            <div className=" clear-both"></div>
                        </div>

                        <div className="container-new-driver">
                            <EditDriverForm
                                parent="DRIVERS"
                                action="NEW"
                                driverNumber="0"
                                isVisible={isAddDriverVisible}
                                policyState={policy.ratedState}
                                drivers={policy.drivers}
                                onCloseAction={(e: any) => {
                                    setIsAddDriverVisible(false);
                                    toggleAddDriver(false);
                                }}
                                onAddAction={onAddAction}
                            />
                            {/* <div className="pl-5 pt-6 pr-5 pb-6  border border-[#dee2e6]">
                                <div className="grid gap-5 grid-cols-12">
                                    <div className="form-group col-span-12 sm:col-span-8 md:col-span-6 lg:col-span-4 xl:col-span-4">
                                        <TextField key="txtFirstName" 
                                            id="txtFirstName" 
                                            name="FirstName" className="p-1 w-full" 
                                            label="First Name" 
                                            variant="outlined" 
                                            //onChange={(e)=>{setFirstName(e.target.value)}} 
                                            inputRef={firstName}
                                            //value={ firstName } 
                                            />
                                    </div>
                                    <div className="form-group col-span-12 sm:col-span-4 md:col-span-3 lg:col-span-2 xl:col-span-2">
                                        <TextField id="txtMiddleInitial" 
                                            name="MiddleInitial" className="p-1"  
                                            label="Middle Initial (optional)" 
                                            variant="outlined" 
                                             //value={middleInitial}
                                             //onChange={(e)=>{}} 
                                             //onBlur={(e)=>{setMiddleInitial(e.target.value)}} 
                                            inputRef={middleInitial}
                                            />
                                    </div>
                                    <div className="form-group col-span-12 sm:col-span-8 md:col-span-6 lg:col-span-4 xl:col-span-4">
                                    <TextField 
                                        id="txtLastName" 
                                        name="LastName" 
                                        className="p-1 w-full" 
                                        label="Last Name" 
                                        variant="outlined" 
                                        //value={lastName}
                                        //onChange={(e)=>{setLastName(e.target.value);}} 
                                        //onBlur={(e)=>{setLastName(e.target.value);}} 
                                        inputRef={lastName}
                                        />
                                    </div>
                                    <div className="form-group col-span-12 sm:col-span-4 md:col-span-3 lg:col-span-2 xl:col-span-2">
                                        <FormControl fullWidth>
                                            <InputLabel id="lbl-ddlSuffix">Suffix (optional)</InputLabel>
                                            <Select
                                                labelId="lbl-ddlSuffix"
                                                id="ddlSuffix"
                                                label="Suffix (optional)"
                                                //value={suffix}
                                                //onChange={(e)=> {setSuffix(e.target.value)}}
                                                value={suffix}
                                                >
                                                <MenuItem value="JR">JR</MenuItem>
                                                <MenuItem value="SR">SR</MenuItem>
                                                <MenuItem value="I">I</MenuItem>
                                                <MenuItem value="II">II</MenuItem>
                                                <MenuItem value="III">III</MenuItem>
                                                <MenuItem value="IV">IV</MenuItem>
                                                <MenuItem value="V">V</MenuItem>
                                                <MenuItem value="VI">VI</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                    <div className=" col-span-12 pt-7 pb-7 text-[#cccccc]">
                                        <hr/>
                                    </div>
                                </div>
                                <div className=" grid grid-cols-12 sm:grid-cols-12 md:grid-cols-12 lg:grid-cols-12 xl:grid-cols-12">
                                    <div className="form-group col-span-2">
                                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                                            <DateField 
                                                label="Date Of Birth" 
                                                
                                                className="w-full"
                                                
                                                // value={dateOfBirth} 
                                                // onChange={(e)=>{
                                                //     setDateOfBirth(e);
                                                // }} 
                                                inputRef={dateOfBirth}
                                                />
                                        </LocalizationProvider>
                                    </div>
                                </div>
                                <div className="pt-5 grid grid-cols-12 sm:grid-cols-12 md:grid-cols-12 lg:grid-cols-12 xl:grid-cols-12">
                                    <div className="form-group col-span-2">
                                        <FormControl fullWidth>
                                            <InputLabel id="lbl-ddlSex">Sex</InputLabel>
                                            <Select 
                                                id="ddlSex"
                                                labelId="lbl-ddlSex"
                                                name="Sex"
                                                label="Sex"
                                                 //value={gender}
                                                 //onChange={(e:any)=> {setGender(e.target.value )}}
                                                inputRef={gender}
                                                >
                                                <MenuItem value={"M"}>Male</MenuItem>
                                                <MenuItem value={"F"}>Female</MenuItem>
                                            </Select>
                                        </FormControl>
                                        
                                    </div>
                                </div>
                       

                                <div className="pt-5  grid grid-cols-12 sm:grid-cols-12 md:grid-cols-12 lg:grid-cols-12 xl:grid-cols-12">
                                    <div className="form-group col-span-2">
                                        <FormControl fullWidth>
                                            <InputLabel id="lbl-ddlMaritalStatus">Marital Status</InputLabel>
                                            <Select
                                                id="ddlMaritalStatus"
                                                name="MaritalStatus"
                                                label="Marital Status"
                                                labelId="lbl-ddlMaritalStatus"
                                                 //value={maritalStatus}
                                                // onChange={(e:any) => { setMaritalStatus(e.target.value) }}
                                                inputRef={maritalStatus}
                                                >
                                                <MenuItem value="S">Single</MenuItem>
                                                <MenuItem value="M">Married</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </div>
                                </div>












                                <div className="pt-5  grid grid-cols-12 sm:grid-cols-12 md:grid-cols-12 lg:grid-cols-12 xl:grid-cols-12">
                                    <div className="form-group col-span-6">
                                        <span className="font-medium text-lg mb-5">Has this driver completed an accident prevention course? (optional)</span>
                                    </div>
                                </div>

                                <ToggleButtonGroup
                                    color="primary"
                                    value={ sameAsMailing}
                                    exclusive
                                    // onChange={(e, newValue)=>{ 
                                    //     setSameAsMailing(newValue);
                                    //     if(newValue == "NO"){
                                    //     }
                                    // }}

                                    ref={sameAsMailing}
                                    aria-label="Platform"
                                >
                                    <ToggleButton className="w-40" value="YES">Yes</ToggleButton>
                                    <ToggleButton className="w-40" value="NO">No</ToggleButton>
                                </ToggleButtonGroup>







                                <div className="pt-10 grid grid-cols-12 sm:grid-cols-12 md:grid-cols-12 lg:grid-cols-12 xl:grid-cols-12">
                                    <div className="form-group col-span-12">
                                        <span className="w-1/3 sm:w-1/3 md:w-1/6 lg:w-1/6 xl:w-1/6 hover:cursor-pointer border border-[#b3b3b3] text-center float-left bg-[#f2f2f2] p-2 rounded-md active:bg-[#000000] active:text-[#fff] hover:bg-[#dfdfdf] float-left" onClick={toggleAddDriver}>Cancel</span>
                                        <span className="w-1/3 sm:w-1/3 md:w-1/6 lg:w-1/6 xl:w-1/6 hover:cursor-pointer text-center float-right bg-[#0071eb] text-[#ffffff] p-2 rounded-md active:bg-[#0a58ca] float-right" onClick={(e)=> { onSaveDriver(e)}}>Save</span>
                                    </div>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>

            <div className="mb-5  mt-28 p-5 bg-[#e0e1dd]">
                <div className="m-auto w-[90vw] sm:w-[90vw] md:w-[90vw] lg:w-[60vw] xl:w-[60vw]">
                    <SecondaryButton onClick={NavigateBack} variant="contained" className="p-2 w-1/3 sm:w-1/3 md:w-1/6 lg:w-1/6 xl:w-1/6 ">Back</SecondaryButton>
                    <Button variant="contained" className="btn-continue hover:cursor-pointer w-1/3 sm:w-1/3 md:w-1/6 lg:w-1/6 xl:w-1/6  float-right bg-[#0071eb] text-[#ffffff] rounded-md active:bg-[#0a58ca]" onClick={NavigateForward}>Continue</Button>
                    <div className="clear-both">

                    </div>
                </div>
            </div>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
                onClick={handleClose}>
                <CircularProgress color="inherit" />
            </Backdrop>




            <Toast isOpen={isOpenErrorAlert} onClose={() => { setIsOpenErrorAlert(false) }} message={errorMessages} severity={toastSeverity} />
        </>
    );
}

export default Drivers;